import { gql } from "graphql-tag";

export const NOTIFICATION_CREATED_SUBSCRIPTION = gql`
  subscription OnNotificationCreated {
    notificationCreated {
      id
      type
      data
      state
    }
  }
`;

export const NOTIFICATION_UPDATED_SUBSCRIPTION = gql`
  subscription OnNotificationUpdated {
    notificationUpdated {
      id
      type
      data
      state
    }
  }
`;
export const USER_NOTIFICATION_SUBSCRIPTION = gql`
  subscription onUserNotificationCreated {
    userNotificationCreated {
      id
      type
      userId
      createdAt
      data {
        ... on FriendUserNotificationData {
          friend {
            avatar
            id
            username
          }
        }
        ... on LeaderboardUserNotificationData {
          name
          banner
          rank
          score
          leaderboardId
          timeFrame
          endDate
          leaderboardType
        }
        ... on TournamentUserNotificationData {
          tournamentId
          gameId
          rank
        }
        ... on AchievementRewardUserNotificationData {
          type
          balance
          isEndScreenReward
        }
        ... on BattleUserNotificationData {
          matchState
          matchId
          gameId
          expiryTime
          host {
            avatar
            id
            username
            xp
            followStatus
            lastCheckin
          }
          opponent {
            username
            avatar
            id
          }
        }
        ... on FollowNotificationData {
          followerUser {
            avatar
            banner
            followStatus
            id
            lastCheckin
            username
            xp
          }
        }
      }
    }
  }
`;
